import type { ReactNode } from 'react'
import './ContentWrapper.scss'

interface Props {
  children: ReactNode
}

function ContentWrapper({ children }: Props) {
  return <div className='content-wrapper'>{children}</div>
}

export default ContentWrapper
